<template>
  <div class="tree-content">
    <el-row
        type="flex"
        align="middle"
        justify="space-between"
        class="tree-header">
      <div class="tree-header-title">
        {{title}}
        <span v-if="subTitle" style="font-size: 12px;color: #999;display: inline-block;">{{subTitle}}</span>
      </div>
      <div>
        <slot name="top-right">
          <div v-gutter="8" class="top-right--icon">
            <gj-button
                v-if="collapseIcon && expand"
                type="text"
                style="padding: 0;"
                @click="expandAll(false)"
            >收起</gj-button>
            <gj-button
                v-if="expandIcon && !expand"
                type="text"
                style="padding: 0;"
                @click="expandAll(true)"
            >展开</gj-button>
            <i v-if="importIcon"
               class="el-icon-upload2 op-icon"
               @click="$emit('import')"></i>
            <i v-if="addIcon"
               class="el-icon-plus op-icon"
               @click="$emit('add')"></i>
          </div>
        </slot>
      </div>
    </el-row>
    <div class="top-input">
      <gj-button
          type="icon"
          plain
          style="font-size: 18px;position: relative; top: 2px; margin-right: 5px;"
          @click="$emit('queryData')"
          v-if="homeIcon"
      ><gj-icon iconfont="iconicon_home"></gj-icon></gj-button>
      <slot name="filter-group">
        <gj-input
            ref="filterInput"
            :width="'80%'"
            v-model="filterText"
            :placeholder="placeholder||'输入关键字进行过滤'">
        </gj-input>
      </slot>
    </div>

      <div class="tree-body" v-loading="loading">
        <el-tree
            ref="tree"
            v-bind="$attrs"
            v-on="$listeners"
            :data="data"
            highlight-current
            default-expand-all
            :expand-on-click-node="expandOnClickNode"
            :filter-node-method="filterNode"
            :style="{height: treeHeight}">
          <template v-slot="{ node, data }">
            <div class=" flex justify-between align-center">
              <slot name="node" :data="data">
                <div class="custom-tree-node-name" :style="{'max-width': 150-(node.level-1)*18 +'px' }">
                  <gj-tooltip :text-line="1" :content="node.label" style="width: 100%;word-wrap: break-word;">
                    {{ node.label }}
                  </gj-tooltip>
                </div>
              </slot>
              <div class="gj-tree-child">
                  <gj-button
                      v-if="editIcon"
                      type="text"
                      style="color: #333; padding: 0;"
                      @click.stop="$emit('edit', data)">
                    <i class="el-icon-edit" :style="{fontSize: editIconSize}"></i>
                  </gj-button>
                  <gj-button
                      v-if="deleteIcon"
                      type="text"
                      style="color: #333; padding: 0; margin-left: 8px;"
                      @click.stop="$emit('delete', data)">
                    <i class="el-icon-delete" :style="{fontSize: deleteIconSize}"></i>
                  </gj-button>
              </div>
            </div>
          </template>
        </el-tree>
      </div>

  </div>
</template>

<script>
  import {isMeaningful} from "../../utils/common";

  export default {
    name: "gj-tree-manager",
    props: {
      title: {
        type: String,
      },
      subTitle: {
        type: String,
      },
      placeholder:{
        type:String,
      },
      data: {
        required: true,
      },
      expandOnClickNode: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      treeHeight: {
        type: String,
        default: '100%'
      },
      collapseIcon: {
        type: Boolean,
        default: false
      },
      addIcon: {
        type: Boolean,
        default: false
      },
      editIcon: {
        type: Boolean,
        default: false
      },
      deleteIcon: {
        type: Boolean,
        default: false,
      },
      importIcon: {
        type: Boolean,
        default: false,
      },
      expandIcon: {
        type: Boolean,
        default: false
      },
      homeIcon:{
        type:Boolean,
        default:false
      },
      editIconSize: {
        default: '12px'
      },
      deleteIconSize: {
        default: '12px'
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    data() {
      return {
        filterText: '',
        expand: true
      };
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      expandAll(expand) {
        this.expand = expand;
        this._expandAll(expand, this.$refs.tree.store.root.childNodes);
      },
      _expandAll(expand, nodes) {
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].expanded = expand;
          if (isMeaningful(nodes[i].childNodes)) {
            this._expandAll(expand, nodes[i].childNodes);
          }
        }
      },
    },
  }
</script>

<style scoped>
.custom-tree-node-name{
  /*white-space: nowrap;*/
  /*text-overflow: ellipsis;*/
  /*overflow: hidden;*/
  color: #333;
  font-size: 12px;
}
  .tree-header {
    min-height: 36px;
    padding: 0 8px;
    background: #fff;
    font-size: 13px;
    border-bottom: 1px solid #EBEEF5;
    box-sizing: border-box;
  }
  .tree-header-title {
    color: #666;
    font-weight: bold;
  }
  .tree-content {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100%;
    /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
  }
  .tree-body {
    /* flex: 1; */
    height: 100%;
    overflow: auto;
  }
  .tree-body::-webkit-scrollbar-track {
      background: #fff;
  }
  .top-input {
    margin-bottom: 10px;
    padding: 10px 8px;
    border-bottom: 1px solid #e8e8e8;
  }
  .top-right--icon {
    font-size: 16px;
    color: #999999;
    cursor: pointer;
  }
  .top-right--icon .op-icon {
    font-weight: bold;
  }
  .gj-tree-child {
    display: none;
    position: absolute;
    right: 8px;
  }
  /deep/ .el-tree--highlight-current .el-tree-node .el-tree-node__content {
    font-size: 12px;
    color: #606266;
  }
  /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    /* border: 1px solid #30adff; */
    /* color: #30adff; */
  }
  /deep/ .el-tree-node .el-tree-node__content {
    padding-right: 10px;
  }
  /deep/ .el-tree-node__label {
    font-size: 13px;
  }
  /deep/ .el-tree-node:not(.is-current):focus > .el-tree-node__content {
    background-color: #EDF7FF;
  }

  /deep/ .el-tree-node > .el-tree-node__children {
    overflow: inherit;
  }
  /deep/ .el-tree-node {
    min-width: fit-content;
  }
  .el-icon-plus{
    margin-left: 12px !important;
  }
</style>
